<template>
    <div class="pods-container">
        <p 
            v-if="resultList.length" 
            class="p-title"
        >پادکست‌های مشابه</p>

        <!-- PODCASTs -->
        <template v-if="resultList.length">
            <div class="favorite-pods">
                <carousel 
                    :perPageCustom="[[0, 3], [325, 5], [992, 7]]" 
                    :spacePadding="15"
                    :paginationEnabled="false"
                >
                    <slide class="slide-item" v-for="(elm, index) in resultList" :key="index">
                        <div class="col-12 podcast-container">
                            <img class="disk-img" :src="Disk" alt="Disk">
                            <router-link 
                                tag='div' 
                                :to="{ name: 'PodcastDetails', params: { id: elm._id }}"
                                class="podcast"    
                                :style="{ 'background-image': 'linear-gradient(180deg, #ddd, transparent), url(' + URL + '/' + elm.Cover + ')' }"
                            >
                            </router-link >
                        </div>
                    </slide>
                </carousel>
            </div>
        </template>

        <!-- No Podcast Available -->
        <template v-else>
            <div class="nopodcast">
                <h5>پادکست مرتبطی یافت نگردید.</h5>
            </div>
        </template>
    </div>
</template>

<script>
import Disk from '@/assets/images/resaneh/disk.png';

import { APP_API_URL } from '@/utils/libs/api-request';
import { Carousel, Slide } from 'vue-carousel';

export default {
    name: 'FavoritePodcasts',
    props: {
        resultList: Array
    },
    components: {
        Carousel,
        Slide,
    },
    data() {
        return {
            Disk: Disk,

            URL: APP_API_URL(),
        };
    },
};
</script>

<style scoped>
/* ---------------------------------------- */
/* ----------- FAVORITE PODCASTs ---------- */
/* ---------------------------------------- */
.pods-container {
    height: 40vh;
    margin: auto 0 0;
}
.pods-container .p-title {
    height: 2rem;
    margin: 1rem 10pt -2rem;

    color: #fff;
    font-weight: bold;
}
.pods-container .favorite-pods {
    padding: 1.5rem 1rem;

    direction: ltr;
}
.pods-container .favorite-pods .slide-item {
    padding: 0 .5rem;
}
.pods-container .favorite-pods .slide-item .inner-item {
    height: 125pt;
    border-radius: 15pt;
    overflow: hidden;
    background-color: #fff;
}

/* ---------------------------------------- */
/* ---------- Podcasts Container ---------- */
/* ---------------------------------------- */
.podcast-container {
    height: 30vh;
    width: 20vh;

    padding: 0 5px !important;

    cursor: pointer;
    margin: 5pt 0 auto;

    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
}
.podcast-container .disk-img {
    min-height: 80pt;
    min-width: 80pt;
    max-height: 10vh;
    max-width: 10vh;

    margin: auto auto -100pt;
}
.podcast-container .podcast {
    height: 20vh;
    width: 20vh;
    margin: 10vh auto auto;
    padding: 15pt 20pt;

    position: relative;
    text-align: center;

    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;

    background-color: #fff;
    border-radius: 15pt;

    direction: rtl;
}
@media (max-width: 576px) {
    .podcast-container .podcast h5 { 
        font-size: 90%;
    }
    .podcast-container .disk-img {
        min-height: 60pt;
        min-width: 60pt;
        max-height: 10vh;
        max-width: 10vh;

        margin: auto auto -75pt;
    }
}

/* ---------------------------------------- */
/* -------------- No PODCAST -------------- */
/* ---------------------------------------- */
.pods-container .nopodcast {
    height: 100pt;
    width: 100%;

    margin: 3rem auto auto !important;
    padding: 25pt 1rem;

    background-color: #fece02;
    border: 1px solid #ddd;

    display: flex;
}
.pods-container .nopodcast h5 {
    margin: auto;
    text-align: center;
}
</style>
